// Department API Service - Backend Integration
import { apiGet, apiPost, apiPut, apiDelete } from '../services/apiClient';

// Helper to wrap response in { data: ... } format for backward compatibility with axios-style responses
const wrapResponse = (data) => ({ data });

export const getDepartments = async (params = {}) => {
  // Use gateway path: /gateway/registration/api/signup/organization/departments
  const endpoint = '/gateway/registration/api/signup/organization/departments';
  
  // Prepare query parameters
  // Note: If isActive is null or undefined, don't include it in query params
  // This allows backend to return all departments (both active and inactive)
  const queryParams = {
    page: params.page || 0,
    size: params.size || 100
  };
  
  // Only add isActive if explicitly set to true or false (not null/undefined)
  if (params.isActive === true || params.isActive === false) {
    queryParams.isActive = params.isActive;
  }
  // If isActive is null or undefined, don't include it - backend will return all departments
  
  try {
    const response = await apiGet(endpoint, queryParams);
    // Backend returns: { data: { content: [...], totalElements, totalPages, ... } }
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to fetch departments from backend:', error);
    throw error;
  }
};

export const createDepartment = async (data) => {
  const endpoint = '/gateway/registration/api/signup/organization/departments';
  const response = await apiPost(endpoint, data);
  return wrapResponse(response);
};

export const getDepartmentById = async (deptId) => {
  const endpoint = `/gateway/registration/api/signup/organization/departments/${deptId}`;
  
  try {
    const response = await apiGet(endpoint);
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to fetch department by ID from backend:', error);
    throw error;
  }
};

export const updateDepartment = async (deptId, data) => {
  const endpoint = `/gateway/registration/api/signup/organization/departments/${deptId}`;
  const response = await apiPut(endpoint, data);
  return wrapResponse(response);
};

export const deleteDepartment = async (deptId) => {
  const endpoint = `/gateway/registration/api/signup/organization/departments/${deptId}`;
  const response = await apiDelete(endpoint);
  return wrapResponse(response);
};

export const getDepartmentsByOrganization = async (orgId) => {
  const endpoint = `/gateway/registration/api/signup/organization/organizations/${orgId}/departments`;
  
  try {
    const response = await apiGet(endpoint);
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to fetch departments by organization from backend:', error);
    throw error;
  }
};

export const getDepartmentTeams = async (deptId) => {
  const endpoint = `/gateway/registration/api/signup/organization/departments/${deptId}/teams`;
  const response = await apiGet(endpoint);
  return wrapResponse(response);
};

export const getDepartmentUsers = async (deptId) => {
  const endpoint = `/gateway/registration/api/signup/organization/departments/${deptId}/users`;
  
  try {
    const response = await apiGet(endpoint);
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to fetch department users from backend:', error);
    throw error;
  }
};

export const getChildDepartments = async (deptId) => {
  const endpoint = `/gateway/registration/api/signup/organization/departments/${deptId}/children`;
  const response = await apiGet(endpoint);
  return wrapResponse(response);
};

export const assignManager = async (deptId, managerId) => {
  const endpoint = `/gateway/registration/api/signup/organization/departments/${deptId}/manager`;
  const response = await apiPut(endpoint, { managerId });
  return wrapResponse(response);
};

// Service object for backward compatibility
export const departmentService = {
  getDepartments,
  createDepartment,
  getDepartmentById,
  updateDepartment,
  deleteDepartment,
  getDepartmentsByOrganization,
  getDepartmentTeams,
  getDepartmentUsers,
  getChildDepartments,
  assignManager,
};

export default departmentService;

